import { init } from "@rematch/core";
import commonStore from "../common/store/common-store";

const store = init({
  models: {
    common: commonStore,
  },
});
export default store;
